import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fda091a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-container" }
const _hoisted_2 = { class: "item-name" }
const _hoisted_3 = { class: "icon-text" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "item-type" }
const _hoisted_7 = { class: "icon-text" }
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "item-sensors" }
const _hoisted_11 = { class: "icon-text" }
const _hoisted_12 = { class: "icon" }
const _hoisted_13 = { class: "text" }
const _hoisted_14 = {
  key: 0,
  class: "icon"
}
const _hoisted_15 = { class: "detail-content" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"detail-header\" data-v-3fda091a><div class=\"header-name\" data-v-3fda091a>Nome</div><div class=\"header-inserted\" data-v-3fda091a>Incluído em:</div><div class=\"header-removed\" data-v-3fda091a>Removido em:</div><div class=\"header-total\" data-v-3fda091a>Total:</div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TenantBillingCard = _resolveComponent("TenantBillingCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-address-card" })
        ]),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.tenant.name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-tags" })
        ]),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.tenant.type), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("span", _hoisted_11, [
        _createElementVNode("span", _hoisted_12, [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-money-bill-wave" })
        ]),
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.sensors), 1)
      ])
    ]),
    _createElementVNode("div", {
      class: "item-more",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showDetails && _ctx.showDetails(...args)))
    }, [
      (_ctx.sensors > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
            (_ctx.showingDetails)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  icon: "fa-solid fa-angle-down"
                }))
              : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: "fa-solid fa-angles-right"
                }))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([{ 'is-expanded': _ctx.showingDetails }, "item-detail"])
    }, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billings, (billing) => {
          return (_openBlock(), _createBlock(_component_TenantBillingCard, {
            key: billing.id,
            billing: billing,
            monthDate: _ctx.monthDate
          }, null, 8, ["billing", "monthDate"]))
        }), 128))
      ])
    ], 2)
  ]))
}